export class Accordion {

    static init()
    {
        const $ = jQuery;
        const accordions = document.getElementById('js-accordions');

        if (accordions) {
            $(document).on('click', '#js-accordions .accordion__head', function () {
                const parent = $(this).parent(".accordion");
                $(parent).siblings('.is-open').removeClass('is-open');
                $(parent).toggleClass('is-open');
            });
        }
    }
}